import React from "react";
import { formatToIndianRupees } from "../../../utils/formatToIndianRupees";
export default function Amounts(props) {
    const {loanDetails, preCloseAmount,foreCloseAmount,totalEmiAmount,isPreClosure,principlePaid,interestPaid,preClosecharges} = props
  return (
    <div
      style={{ display: "flex", justifyContent: "space-between", gap: "12px" }}
    >
      <div
        style={{
          backgroundColor: "#ecfdf5",
          border: "1px solid #d0fae5",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color: "#009966", fontSize: "12px" }}>
          PAID INTEREST
        </p>
        <p
          style={{
            fontWeight: "800",
            color: "#007a55",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees(interestPaid)}
        </p>
      </div>
       <div
        style={{
          backgroundColor: "#ecfdf5",
          border: "1px solid #d0fae5",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color: "#009966", fontSize: "12px" }}>
          PAID PRINCIPAL
        </p>
        <p
          style={{
            fontWeight: "800",
            color: "#007a55",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees(principlePaid)}
        </p>
      </div>
       
      <div
        style={{
          backgroundColor: "#ecfdf5",
          border: "1px solid #d0fae5",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color: "#009966", fontSize: "12px" }}>
          TOTAL PAID
        </p>
        <p
          style={{
            fontWeight: "800",
            color: "#007a55",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees(loanDetails.paidAmount)}
        </p>
      </div>
      <div
        style={{
          backgroundColor: "#FEEAEB",
          border: "1px solid #ffe2e2",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color: "#e7000b", fontSize: "12px" }}>
          TOTAL OUTSTANDING
        </p>
        <p
          style={{
            fontWeight: "800",
            color: "#D22129",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees((loanDetails?.facilityType === 1 || loanDetails?.facilityType === 5)?loanDetails.outstandingAmount:(loanDetails.loanAmount - principlePaid))}
        </p>
      </div>
      <div
        style={{
          backgroundColor: "#F9FAFB",
          border: "1px solid #e2e8f0",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color: "#667085", fontSize: "12px" }}>
          Loan / Disbursed Amt
        </p>
        <p
          style={{
            fontWeight: "800",
            color: "#667085",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees(loanDetails.loanAmount)} /{" "}
          {formatToIndianRupees(loanDetails.disbursedAmount)}
        </p>
      </div>
 <div
        style={{
         background:"#d5e8faff",
          border: "1px solid #adceeeff",
          padding: "8px 12px 8px 12px",
          lineHeight: 1,
          borderRadius: "8px",
        }}
      >
        <p style={{ fontWeight: "bold", color:"#358fe9ff", fontSize: "12px" }}>
          Preclose Amount
        </p>
        <p
          style={{
            fontWeight: "800",
           color:"#1976d2",
            fontSize: "14px",
            marginBottom: "0px",
          }}
        >
          {formatToIndianRupees((loanDetails?.facilityType === 1 || loanDetails?.facilityType === 5) ?(preCloseAmount-preClosecharges):preCloseAmount )}
        </p>
      </div>
     
    </div>
  );
}
